// src/components/RegisterScreen.jsx

import React, { useState, useEffect } from 'react';
import './LoginScreen.css'; // ✅ Reuse existing styles
import { authFetch } from '../utils/authFetch';

export default function RegisterScreen({ setUiState }) {
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);


  useEffect(() => {
    setError(null);
    setSuccess(false);
  }, []);

  useEffect(() => {
    const loadRoles = async () => {
      console.log("API URL:", process.env.REACT_APP_API_URL);
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/roles`);
        if (!res.ok) throw new Error("Failed to fetch roles");
        const data = await res.json();
        setRoles(data.sort((a, b) => a.label.localeCompare(b.label)));
      } catch (err) {
        console.error('Failed to load roles', err);
      }
    };

    loadRoles();
  }, []);

  const handleRegister = async (e) => {
    e.preventDefault();
    const username = e.target.username?.value;
    const password = e.target.password?.value;
    const confirmPassword = e.target.confirmPassword?.value;
    const email = e.target.email?.value;
    const company = e.target.company?.value;
    const role = selectedRole;

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/register/`, {
        method: 'POST',
        body: JSON.stringify({ username, password, email, company, role }),
      });

      const json = await res.json();
      if (!res.ok) throw new Error(json.error || 'Registration failed');
      setSuccess(true);
      setError(null); // ✅ Clear any lingering error

      //redirect after 3 seconds
      setTimeout(() => {
        setUiState('login'); // or navigate to a confirmation screen if you prefer
      }, 3000);

    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-screen">
        <h2>Register</h2>
        <form onSubmit={handleRegister}>
            <input name="username" placeholder="Username" required onChange={() => setError(null)}/>
            <input name="email" type="email" placeholder="Email" required />
            <input name="company" placeholder="Company" required />
            <select 
              name="role" 
              required
              value={selectedRole}
              onChange={(e) => setSelectedRole(e.target.value)}
            >
              <option value="" disabled style={{ color: '#888' }}>
                Position/Role
              </option>
              {roles.map(({ value, label }) => (
                <option key={value} value={value}>{label}</option>
              ))}
            </select>

          {/*  <input name="password" type="password" placeholder="Password" required /> */}
            <div className="input-with-icon">
              <input
                name="password"
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                required
                className="input-field"
              />
              <i
                className={`fa-regular ${showPassword ? "fa-eye" : "fa-eye-slash"} toggle-icon`}
                onClick={() => setShowPassword((prev) => !prev)}
                style={{ marginLeft: "8px", cursor: "pointer" }}
                aria-label="Toggle password visibility"
              />

            </div>

            {/* <input name="confirmPassword" type="password" placeholder="Confirm Password" onChange={() => setError(null)} required /> */}
            <div className="input-with-icon">
              <input
                name="confirmPassword"
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm Password"
                required
                className="input-field"
              />
              <i
                className={`fa-regular ${showConfirmPassword ? "fa-eye" : "fa-eye-slash" } toggle-icon`}
                onClick={() => setShowConfirmPassword((prev) => !prev)}
                style={{ marginLeft: "8px", cursor: "pointer" }}
                aria-label="Toggle confirm password visibility"
              />

            </div>

            <button type="submit" disabled={success}>Register</button>
        </form>
        {/* {error && <p style={{ color: 'red' }}>{error}</p>} */}
        <p className="register-link">
            {success && <span className="success-message">Registration successful. Please check your email to confirm your account. </span>}
            {error && <span style={{ color: 'red' }}>{error}. </span>}
            <a
                href="#"
                onClick={(e) => {
                e.preventDefault();
                setUiState('login');
                }}
                style={{ color: '#007bff', textDecoration: 'none', cursor: 'pointer' }}
            >
                Return to login
            </a>
        </p>
      </div>
    </div>
  );
}
